module.exports = __webpack_public_path__ + "static/SquareSerif-Book-webfont-f68c8ecbcf8b9c31ac9c66bcddfb747e.ttf";